import {Space} from "antd";
import {SessionCoverImagesFormFieldsProps} from "./types";
import {NewOfferingCoverImagesUpload} from "../../../general/cover-images";

export function SessionCoverImagesFormFields({
  accordionIndex,
  defaultCoverImages,
  deleteCoverImage,
  isDeleteLoading,
  isUploadLoading,
  offeringId,
  uploadCoverImages,
}: SessionCoverImagesFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <NewOfferingCoverImagesUpload
        defaultCoverImages={defaultCoverImages}
        deleteCoverImage={deleteCoverImage}
        isDeleteLoading={isDeleteLoading}
        isUploadLoading={isUploadLoading}
        offeringId={offeringId}
        uploadCoverImages={uploadCoverImages}
        offeringType="service"
      />
    </Space>
  );
}
